import { useEffect } from "react"

type ActionProps = string
type CallBackProps = (args: any) => any

const isJson = (json: string) => {
  try {
    const obj = JSON.parse(json)
    return !!obj && typeof obj === "object"
  } catch (e) {
    return false
  }
}

export const useGetReactNativePayload = (
  _action: ActionProps,
  callback: CallBackProps
) => {
  useEffect(() => {
    const handleMessage = (event: any) => {
      if (event && event?.data && isJson(event.data)) {
        try {
          const message = JSON.parse(event.data)
          const { action, payload } = message
          if (action === _action) {
            Promise.resolve(callback(payload)).then((result: any) => result)
          }
        } catch (error) {
          console.error("Error parsing message:", error)
        }
      }
    }

    window.addEventListener("message", handleMessage)
    document.addEventListener("message", handleMessage)

    return () => {
      window.removeEventListener("message", handleMessage)
      document.removeEventListener("message", handleMessage)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_action, callback])
}
